var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Vínculo do Aluno","titleIcon":"fas fa-user-friends"}},[_c('form-aluno',{attrs:{"paramId":_vm.id},on:{"onSubmitTransporteAluno":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }